import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';
import { DashboardPage } from '../dashboard/dashboard/dashboard';
import { GlobalPage } from '../global/global';

@Component({
  templateUrl: 'tabs.html',
  // styleUrls: [ 'tabs.scss', '../../theme/variables.scss' ]

})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = GlobalPage;
  tab3Root = AboutPage;
  tab4Root = ContactPage;
  tab5Root = DashboardPage;
  myIndex: number;
  constructor(navParams: NavParams) {
    this.myIndex = navParams.data.tabIndex || 0;
    console.log(this.myIndex);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts